import {
  customerMarketShopfrontApi,
  customerMarketShopfrontJobsApi,
  Site
} from '@envato/foundation-types'
import * as React from 'react'
import { connect } from 'react-redux'
import { RouteConfigComponentProps } from 'react-router-config'

import {
  fetchFeaturedPageDataBySite,
  onBeforeFeaturePageView
} from '../../common/actions/featurePage'
import { IRootState } from '../../common/reducers'
import { IEnhancedLocation } from '../../common/reducers/reactRouterLocation'
import { decorateSearchResult } from '../../common/selectors/searchResults'
import { IPageComponent } from '../../typings/pageComponent'
import { IItem } from '../../typings/searchResults'
import FeaturedPage from '../pages/feature/featurePage'

interface IOwnProps extends RouteConfigComponentProps<any> {
  location: any // TODO: REMOVE THIS WHEN LOCATION IS NOT ADDING QUERY
}

interface IStateProps {
  metadata: customerMarketShopfrontApi.ISeoMetadata | null
  featuredItems: IItem[]
  featuredAuthors: customerMarketShopfrontJobsApi.IFeaturedAuthorsResult
  location: IEnhancedLocation
  experimentsReady: boolean
  isLoading: boolean
  currentSite: Site
}

const mapStateToProps = (state: IRootState): IStateProps => {
  const {
    featuredPage: {
      featuredItems: featuredItemsMatches,
      featuredAuthors,
      isLoading,
      metadata
    }
  } = state
  const { location } = state.router
  const { experimentsReady } = state.experiments
  const { currentSite } = state.common

  const featuredItems =
    (featuredItemsMatches &&
      featuredItemsMatches.matches.map(match =>
        decorateSearchResult(state, match)
      )) ||
    []

  return {
    metadata,
    featuredItems,
    featuredAuthors: featuredAuthors || [],
    location,
    experimentsReady,
    currentSite,
    isLoading
  }
}

export type Props = IOwnProps & IStateProps

const createFeaturePageContainer = (component: React.ComponentType<Props>) => {
  const pageComponent: IPageComponent<Props> = component as IPageComponent<
    Props
  >

  pageComponent.loadData = ({ store, location, apiAppUrlPrefix }) =>
    store.dispatch(fetchFeaturedPageDataBySite({ location, apiAppUrlPrefix }))

  pageComponent.onBeforePageView = ({ store }) =>
    store.dispatch(onBeforeFeaturePageView())

  return connect<IStateProps, null, IOwnProps, IRootState>(mapStateToProps)(
    pageComponent
  )
}

export default createFeaturePageContainer(FeaturedPage)
